import React, {FC, useContext, useEffect, useState} from "react";
import {
  Box,
  FormControl,
  FormControlLabel,
  Checkbox,
  Grid,
  Typography,
  Card,
  CardContent,
} from "@material-ui/core";
import styled from "styled-components/macro";
import { useDispatch, useSelector } from "react-redux";
import { AppStateType } from "../../../../redux/reducers";
import { useTranslation } from "react-i18next";
import {
  createA11y,
  deleteA11y,
  fetchA11yes,
  updateA11y,
} from "../../../../redux/actions/a11yesActions";
import { GradientText, GradientWrapper } from "./SwitchControl";
import { FeedBackInfoMap, ModalController } from ".";
import { UnitStandardContext } from "../QuestionTabs";
import {checkDependsCondition} from "../../../../utils/functions";

const QTitle = styled(Box)`
    ${(props) => props.theme.breakpoints.down("sm")} {
      font-size: 14px;
    }
`

type CheckboxType = {
  attribute: any;
  itemKey: any;
  unitId: any;
};



type FormControlCheckbox = {
  value: string,
  title: string,
  index: number,
  label: string,
  unitId: string,
  itemKey: any,
  filterA11yesByItemKey: any,
  a11y: any,
  onSetA11y: (value: any) => void,
  checkboxstate: any,
  attribute: any
}
const FormControlCheckbox: FC<FormControlCheckbox> = ({
  value,
  title,
  index,
  label,
  unitId,
  itemKey,
  filterA11yesByItemKey,
  a11y,
  onSetA11y,
  checkboxstate,
  attribute
}) => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const user: any = useSelector(
    (state: AppStateType) => state.authReducer.user
  );
  const onCreateA11y = async (a11yData: any) => {
    dispatch(createA11y(a11yData, user.token));
    // dispatch(fetchA11yes(unitId, user.token));
  };

  const onFetchA11y = async() => {
    await dispatch(fetchA11yes(unitId, user.token))
  }

  const onUpdateA11y = async (a11yData: any) => {
    const a11yIndex = filterA11yesByItemKey.findIndex(
      (item: any) => item.attribute === a11y.attribute
    );
    dispatch(updateA11y(a11yIndex, a11y.id, a11yData, user.token));
    // dispatch(fetchA11yes(unitId, user.token));
  };

  const onDelete = async (a11Data: any) => {
    const a11yIndex = filterA11yesByItemKey.findIndex(
      (item: any) => item.attribute === a11y.attribute
    );

    const a11yId = filterA11yesByItemKey.find(
      (item: any) => item.attribute === a11Data.attribute
    );

    await dispatch(deleteA11y(a11yId.id, user.token, a11yIndex));
    onSetA11y({});
  };

  const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    setLoading(true)
    const a11yData = {
      item: itemKey,
      attribute: `${attribute.key}__${e.target.value}`,
      accessibility_unit: unitId,
    };

    const checked = checkboxstate.includes(a11yData.attribute);

    if (!a11y.id && !checked) {
      await onCreateA11y(a11yData);
      await onFetchA11y();
    } else if (a11y.id && !checked) {
      await onUpdateA11y(a11yData);
      await onFetchA11y();
    } else if (checked) {
      await onDelete(a11yData);
      await onFetchA11y();
    }
    setLoading(false)
  };

  const checkA11yesStatus = (value: string) => {
    const a11yData = {
      item: itemKey,
      attribute: `${attribute.key}__${value}`,
      accessibility_unit: unitId,
    };

    if (checkboxstate.includes(a11yData.attribute)) {
      return true;
    }

    return false;
  };


  return (
    <FormControlLabel
      value={value}
      label={title}
      key={index}
      control={
        <Checkbox
          checked={checkA11yesStatus(value)}
          disabled={loading}
          onChange={handleChange}
          name={label}
        />
      }
    />
  )
}

export default function CheckboxControl({
  attribute,
  itemKey,
  unitId,
}: CheckboxType) {
  const { t } = useTranslation();
  const a11yes: any = useSelector(
    (state: AppStateType) => state.a11yesReducer.a11yes
  );
  const [filterA11yesByItemKey, setFilterA11yesByItemKey] = useState<any>([])
  const [a11y, setA11y] = useState<any>({});
  const [checkboxstate, setCheckboxstate] = useState([]);

  useEffect(() => {
    if (a11yes.length > 0 && itemKey) {
      const filteredA11yesByItemKey = a11yes.filter((i: any) => i.item === itemKey)
      setFilterA11yesByItemKey(filteredA11yesByItemKey)
      setCheckboxstate(filteredA11yesByItemKey.map((item: any) => item.attribute));
    } if (a11yes.length === 0 && itemKey) {
      setFilterA11yesByItemKey([])
      setCheckboxstate([])
    }
  }, [a11yes, itemKey])

  const unitStandard = useContext(UnitStandardContext);

  const currentFeedback = FeedBackInfoMap.find((el) => {
    if (!el.attribute) {
      return el.key === attribute.key && el.unit_key === unitStandard.key;
    }
    return (
      el.key === attribute.key &&
      el.unit_key === unitStandard.key &&
      el.attribute &&
      a11y &&
      a11y.attribute === el.attribute
    );
  });
  const feedbackMap = {
    q_title: attribute.q_title,
    img: currentFeedback ? currentFeedback.img : "",
  };

  return (
    <>
      {checkDependsCondition(a11yes, attribute.depends_on) ? (
        <Box mt={3}>
          <Card>
            <CardContent>
              <FormControl fullWidth>
                <Typography variant="h6">
                  {attribute.is_mandatory === true ? (
                    <GradientWrapper>
                      <GradientText>{t("CLP_UnitMandatoryLabel")}</GradientText>
                    </GradientWrapper>
                  ) : null}
                  <Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <QTitle>{attribute.q_title}</QTitle>
                      <ModalController
                        showButton={!!currentFeedback}
                        feedbackMap={feedbackMap}
                      />
                    </div>
                  </Box>
                </Typography>
                <Box mt={3}>
                  <Grid container>
                    {attribute.values.map((item: any, index: any) => (
                      <Grid item xs={4} key={index}>
                        <FormControlCheckbox
                          value={item.key}
                          title={item.title}
                          index={index}
                          label={item.label}
                          unitId={unitId}
                          itemKey={itemKey}
                          filterA11yesByItemKey={filterA11yesByItemKey}
                          a11y={a11y}
                          onSetA11y={setA11y}
                          checkboxstate={checkboxstate}
                          attribute={attribute}
                        />
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </FormControl>
            </CardContent>
          </Card>
        </Box>
      ) : null}
    </>
  );
}
